module.exports = __webpack_public_path__ + "img/5.c9cad242.jpg";